export default "__VITE_ASSET__FQTswCCP__"